import * as React from 'react';
import { FC, useCallback, useState } from 'react';

import { Box, Header, Icon, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { GeolocationDeniedModal } from 'components/geolocation-denied-modal';
import { LayoutContainer } from 'components/layout/styled';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useGeolocation } from 'state/geolocation';
import { portalToReplaceHeader } from 'state/mobile-header-nav';
import { isNative } from 'utils/environment';
import { routes } from 'utils/routing';

import {
  GeneralBottomContainer,
  GeneralTopContainer,
  InnerBottomContainer,
  InnerGrayContainer,
  InnerWhiteContainer,
  LeftButtonOne,
  LeftButtonThree,
  LeftButtonTwo,
  RightButton,
  StyledImageBackground,
  WalmartLogoContainer,
} from './styled';

export const WalmartLocation: FC<React.PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();

  const { navigate } = useNavigation();
  const { isPermissionPrompt, isPermissionDenied, setPermissionChecking } = useGeolocation();
  const [geolocationDeniedModalOpen, setGeolocationDeniedModalOpen] = useState(false);
  const dismissModal = () => setGeolocationDeniedModalOpen(false);

  const handleGeolocationPrompt = useCallback(() => {
    if (isPermissionDenied) {
      setGeolocationDeniedModalOpen(true);
    } else if (isPermissionPrompt) {
      setPermissionChecking();
    }
  }, [isPermissionDenied, isPermissionPrompt, setPermissionChecking]);
  const HiddenAppHeader = portalToReplaceHeader(() => null);

  return (
    <LayoutContainer isFullContainer={true} backgroundColor={'white'}>
      <HiddenAppHeader />
      <GeneralTopContainer isNative={isNative}>
        <Box>
          <LeftButtonOne />
          <LeftButtonTwo />
          <LeftButtonThree />
        </Box>
        <InnerWhiteContainer>
          <InnerGrayContainer>
            <StyledImageBackground
              source={require('./BurgerKingWalmart-min.jpeg')}
              imageStyle={{
                borderTopLeftRadius: 30,
                borderTopRightRadius: 30,
              }}
            >
              <WalmartLogoContainer>
                <Icon variant="walmartLogo" aria-hidden size={100} />
              </WalmartLogoContainer>
            </StyledImageBackground>
          </InnerGrayContainer>
        </InnerWhiteContainer>
        <RightButton />
      </GeneralTopContainer>
      <GeneralBottomContainer>
        <InnerBottomContainer>
          <Header textAlign="center">{formatMessage({ id: 'yourWalmartPlusOffers' })}</Header>
          <Text textAlign="center" mb="$8">
            {formatMessage({ id: 'letsFindARestaurantToStartOrdering' })}
          </Text>
          <ActionButton
            width="$90"
            onPress={handleGeolocationPrompt}
            _text={{ fontSize: 'md' }}
            mb="$4"
          >
            {formatMessage({ id: 'shareMyLocation' })}
          </ActionButton>
          <ActionButton
            variant={ActionButtonVariants.TEXT_ONLY}
            onPress={() => navigate(routes.base)}
          >
            {formatMessage({ id: 'notNow' })}
          </ActionButton>
        </InnerBottomContainer>
      </GeneralBottomContainer>
      <GeolocationDeniedModal isOpen={geolocationDeniedModalOpen} dismissModal={dismissModal} />
    </LayoutContainer>
  );
};
